import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';
import './Faq.css';

function Faq() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  const sections = [
    {
      title: 'サービスについて',
      items: [
        {
          q: '登録しないと使えませんか？',
          a: '募集の閲覧は一部可能でも、応募・メッセージ・募集作成などの主要機能は登録が必要です。安心・安全のため、プロフィール整備をお願いしております。',
        },
        {
          q: 'どんな人が利用していますか？',
          a: '登山仲間を探している初心者から経験者まで、さまざまな方が利用しています。日帰り登山、ゆる登山、写真目的、トレーニング目的など、募集ごとに目的やレベルが異なります。参加前に募集内容をよく確認してください。',
        },
        {
          q: '所属メンバー募集と単発募集の違いは何ですか？',
          a: '単発募集は、特定の1回の山行に参加するための募集です。所属メンバー募集は、継続的に一緒に活動する仲間を探すための募集です。気軽に参加したい場合は単発募集、長く一緒に登りたい場合は所属メンバー募集がおすすめです。',
        },
      ],
    },
    {
      title: '安全・責任について',
      items: [
        {
          q: '雨天・悪天候の場合はどうなりますか？',
          a: '催行可否は募集者の判断となります。天候、登山道状況、参加者の安全を優先して、中止・延期になる場合があります。参加者は、出発前に必ず最新の連絡をご確認ください。',
        },
        {
          q: '保険への加入は必要ですか？',
          a: 'ヤマッチとして加入を強く推奨します。登山は転倒・滑落・遭難などのリスクがあるため、山岳保険や傷害保険への加入をご検討ください。補償内容はご自身でご確認ください。',
        },
        {
          q: '装備が足りない場合でも参加できますか？',
          a: '募集内容に記載された必要装備を満たしていない場合は、参加を見送るか、事前に募集者へ確認してください。安全確保に必要な装備が不足している場合、参加をお断りすることがあります。',
        },
        {
          q: '体力や経験に自信がない場合はどうすればよいですか？',
          a: '無理をしないことが最優先です。募集の難易度、歩行時間、標高差、必要装備を確認し、少しでも不安があれば募集者に事前に相談してください。当日は体調不良を感じた場合も、無理に参加しないでください。',
        },
      ],
    },
    {
      title: '募集・参加について',
      items: [
        {
          q: '応募したら自動で参加確定になりますか？',
          a: 'いいえ。募集によっては、募集者の確認や承認をもって参加確定となります。応募後はメッセージや通知を確認してください。',
        },
        {
          q: '募集者から返事が来ない場合はどうすればいいですか？',
          a: 'まずは一定時間お待ちください。それでも返答がない場合は、応募をキャンセルした上で別の募集を検討することをおすすめします。不適切な放置や不誠実な対応が繰り返される場合は、必要に応じて運営へご報告ください。',
        },
        {
          q: '参加を断られることはありますか？',
          a: 'はい、あります。募集者は安全性や募集条件との適合を考慮して参加者を判断する場合があります。難易度・装備・経験・募集目的との相性によって、お断りとなることがあります。',
        },
        {
          q: '募集内容を変更したい場合はどうすればいいですか？',
          a: '日程、行き先、集合方法、必要装備などを変更する場合は、参加予定者に分かるよう早めに周知してください。大きな変更がある場合は、参加者が再判断できるよう丁寧な説明をお願いします。',
        },
        {
          q: '募集を取り下げることはできますか？',
          a: 'はい、可能です。ただし、すでに応募者や参加予定者がいる場合は、必ず事情を説明し、できるだけ早く連絡してください。',
        },
        {
          q: '無断キャンセルをした場合はどうなりますか？',
          a: '無断キャンセルや、直前キャンセルの繰り返しは、他のユーザーに大きな迷惑をかけます。状況に応じて注意、機能制限、利用停止の対象となる場合があります。理由がある場合は丁寧に説明するようにしてください。',
        },
      ],
    },
    {
      title: 'メッセージ・やり取りについて',
      items: [
        {
          q: '参加前に何を確認すればよいですか？',
          a: '少なくとも以下は確認することをおすすめします。\n・集合場所・時間\n・予定コース\n・難易度・歩行時間\n・必要装備\n・雨天時の対応\n・キャンセル時の連絡方法',
        },
        {
          q: '外部SNSや連絡先の交換はしてもいいですか？',
          a: '安全上の観点から、サービス内で十分に信頼関係ができるまでは慎重に判断してください。ご自身の責任で問題ないと判断できる場合のみ、許可しております。登山と関係のない勧誘や、しつこい連絡先交換の要求は迷惑行為として制限対象になる場合があります。',
        },
      ],
    },
    {
      title: 'プライバシーについて',
      items: [
        {
          q: 'どの情報が他のユーザーに見えますか？',
          a: 'プロフィールには、公開される項目と、必要な場合のみ共有される項目があります。公開範囲や共有タイミングは、サービス内の仕様に従って管理されます。公開したくない情報は、プロフィール登録時に内容をよくご確認ください。',
        },
        {
          q: '本名や連絡先の登録は必要ですか？',
          a: '安全上の必要性がある場合を除き、個人情報の共有は原則禁止です。他のユーザーに本名や連絡先の公開を求めるものではありません。',
        },
        {
          q: '退会したら情報はどうなりますか？',
          a: '法令上または運営上保管が必要な情報を除き、退会後は所定の方針に基づいて処理されます。詳細は利用規約・プライバシーポリシーをご確認ください。',
        },
      ],
    },
    {
      title: 'トラブル・通報について',
      items: [
        {
          q: 'どんな内容が通報対象になりますか？',
          a: '例えば以下のような行為は通報対象です。\n・危険な登山計画の掲載\n・ハラスメントや威圧的言動\n・出会い目的・ナンパ行為\n・外部サービスへの勧誘\n・虚偽情報の登録\n・無断キャンセルの繰り返し\n・不適切なメッセージ送信',
        },
        {
          q: '通報したらすぐに対応してもらえますか？',
          a: '内容の確認にはお時間をいただく場合があります。ただし、危険性や緊急性が高い内容は優先的に確認・対応します。',
        },
        {
          q: '緊急性の高いトラブルのときはどうすればいいですか？',
          a: '生命・身体に関わる緊急事態や、犯罪被害のおそれがある場合は、まず警察・消防・関係機関へご相談ください。ヤマッチの通報機能は、緊急通報窓口の代替ではありません。',
        },
      ],
    },
    {
      title: '禁止事項について',
      items: [
        {
          q: '商用利用はできますか？',
          a: '登山と無関係な営業、勧誘、集客、宣伝目的での利用は禁止です。運営が不適切と判断した場合、投稿削除や利用制限の対象となります。',
        },
        {
          q: '異性との出会いを目的にした募集はできますか？',
          a: 'できません。ヤマッチは登山仲間を見つけるためのサービスであり、恋愛・ナンパ・交際目的での利用は禁止です。',
        },
        {
          q: '虚偽のプロフィールや経歴を書いてもいいですか？',
          a: 'できません。登山経験、装備、体力、年齢層、活動目的などについて誤解を招く記載は、トラブルや事故の原因になります。悪質な場合は利用制限の対象となります。',
        },
      ],
    },
    {
      title: 'その他',
      items: [
        {
          q: '募集者・参加者のどちらが偉いということはありますか？',
          a: 'ありません。募集者は計画を主導する立場ですが、参加者も対等な利用者です。お互いに敬意を持ってやり取りしてください。',
        },
        {
          q: '安全に利用するために最初にやるべきことは何ですか？',
          a: 'まずはプロフィールを整え、自分の経験や登山スタイルが伝わる状態にしてください。そのうえで、無理のない難易度の募集を選び、事前に不明点を確認することをおすすめします。',
        },
      ],
    },
  ];

  return (
    <div className="terms-container">
      <div className="terms-header">
        <Link to="/" className="back-link">← ホームへ</Link>
        <h1>よくある質問</h1>
      </div>

      <div className="terms-content">
        {sections.map((section) => (
          <section key={section.title} className="terms-section faq-section">
            <h2>{section.title}</h2>
            <div className="faq-list">
              {section.items.map((item) => (
                <div key={item.q} className="faq-item">
                  <p className="faq-q">Q. {item.q}</p>
                  <p className="faq-a">
                    {item.a.split('\n').map((line, i) => (
                      <React.Fragment key={i}>{line}{i < item.a.split('\n').length - 1 && <br />}</React.Fragment>
                    ))}
                  </p>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default Faq;
